import { FC, useCallback } from 'react';
import styles from '../../assets/scss/ReactiveModal/ReactiveModal.module.scss';
import { ReactiveModalViewType } from '../../types/view/ReactiveModalViewType';
import { CommonModal } from '../CommonModal';
import { postMessageGtag } from '../../utils/trackClick';

export const ReactiveModal: FC<{
  active: boolean;
  closeFunc: () => void;
  ReactiveModal: ReactiveModalViewType | null;
  clickSubmitFunc: () => void;
  loading: boolean;
}> = ({ active, closeFunc, ReactiveModal, clickSubmitFunc, loading }) => {
  const clickSubmitHandler = useCallback(() => {
    clickSubmitFunc();
  }, [clickSubmitFunc]);

  if (!ReactiveModal) return <></>;

  const content = (
    <div className={styles.container}>
      {/* タイトル */}
      <p className={styles.title}>おかえりなさい！</p>

      {/* テキスト */}
      <div className={styles.textArea}>
        再開してお好きな商品や
        <br />
        お届け日に変更してお楽しみください。
      </div>

      {/* ボタン */}
      <div className={styles.btnContainer}>
        <button
          onClick={() => {
            clickSubmitHandler();
            postMessageGtag('click_restart', 'top');
          }}
          disabled={loading}
        >
          定期オトク便を再開する
        </button>
      </div>

      {/* 注意文言 */}
      <div className={styles.attention}>再開後すぐに注文は確定されません。</div>
    </div>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
      isMaxHeight={false}
    >
      {content}
    </CommonModal>
  );
};
